import {
  hasFeatureInLocalStorage,
  REFERRAL_REPLY_DEPARTMENT_FILTER_FEATURE,
} from '../global/featureFlags';

const parseLocalStorageArray = (key) => {
  try {
    const parsedValue = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch {
    return [];
  }
};

export const getCachedSmsTemplates = () => parseLocalStorageArray('referral_sms_template');

export const getCachedReferralReplyTemplates = () => parseLocalStorageArray('referral_reply_templates');

// Availability checks (does this org have any usable reply template?) must not
// count archived templates — an org whose every template is archived should not
// see the Reply action at all. The full cached list (above) is still what the
// reply modal loads, so a historical resend can label its archived template.
// `!== false` keeps cached payloads from before the archive feature working.
export const getActiveCachedReferralReplyTemplates = () => getCachedReferralReplyTemplates()
  .filter((template) => template && template.active !== false);

export const getCachedReferralCallTemplates = () => parseLocalStorageArray('referral_call_templates');

export const getCachedDepartmentIds = () => parseLocalStorageArray('departments')
  .map((department) => department && department.id)
  .filter((departmentId) => departmentId !== undefined && departmentId !== null);

// When the department filter is enabled and a selected referral record has a
// department owner, match the Referral Reply dropdown: organization templates
// plus templates owned by that record's department. Callers without record
// ownership context, or organizations without the flag, retain the legacy
// current-user department visibility behavior.
export const getVisibleSmsTemplatesForCurrentUser = (recordOwnerType, recordOwnerId) => {
  const userDepartmentIds = getCachedDepartmentIds();
  const recordDepartmentId = hasFeatureInLocalStorage(REFERRAL_REPLY_DEPARTMENT_FILTER_FEATURE)
    && recordOwnerType === 'Department' && recordOwnerId != null
    ? String(recordOwnerId)
    : null;

  return getCachedSmsTemplates().filter((template) => {
    if (!template || template.owner_type === 'Organization') return Boolean(template);
    if (template.owner_type !== 'Department') return false;

    const userCanAccessTemplate = userDepartmentIds.some(
      (departmentId) => String(departmentId) === String(template.owner_id),
    );
    return userCanAccessTemplate
      && (!recordDepartmentId || String(template.owner_id) === recordDepartmentId);
  });
};
